import axios from 'axios';
import { getAuthHeader } from './authService';

const API_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface DaySchedule {
  available: boolean;
  startTime?: string;
  endTime?: string;
  breakTimes?: string[];
}

export interface WeeklySchedule {
  monday: DaySchedule;
  tuesday: DaySchedule;
  wednesday: DaySchedule;
  thursday: DaySchedule;
  friday: DaySchedule;
  saturday: DaySchedule;
  sunday: DaySchedule;
}

export interface ProviderAppointmentSettingsRequest {
  slotDuration: number;
  bufferTime?: number;
  maxAdvanceBooking?: number;
  minAdvanceBooking?: number;
  autoApprove?: boolean;
  allowStudentCancellation?: boolean;
  cancellationDeadline?: number;
  weeklySchedule: WeeklySchedule;
}

export interface ProviderAppointmentSettingsResponse extends ProviderAppointmentSettingsRequest {
  lastUpdated?: string;
  availableDays?: string[];
  totalSlotsPerWeek?: number;
  averageSlotsPerDay?: number;
}

class ProviderAppointmentService {
  // Get appointment settings
  async getAppointmentSettings(): Promise<ProviderAppointmentSettingsResponse> {
    const response = await axios.get(`${API_URL}/provider/appointment-settings`, {
      headers: getAuthHeader()
    });
    return response.data;
  }

  // Update appointment settings
  async updateAppointmentSettings(settings: ProviderAppointmentSettingsRequest): Promise<ProviderAppointmentSettingsResponse> {
    const response = await axios.post(`${API_URL}/provider/appointment-settings`, settings, {
      headers: getAuthHeader()
    });
    return response.data;
  }

  // Check if settings are configured
  async hasConfiguredSettings(): Promise<boolean> {
    const response = await axios.get(`${API_URL}/provider/appointment-settings/configured`, {
      headers: getAuthHeader()
    });
    return response.data.configured;
  }
}

export default new ProviderAppointmentService();